import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { QualitativeInput } from './qualitative-input.model';
import { QualitativeProcess } from '../../../../graphql/generated';

export const QualitativeInputActions = createActionGroup({
  source: 'QualitativeInput/API',
  events: {
    'Load QualitativeInputs': props<{ legalEntityId: string, campaignId: string, params?: any, completed?: boolean | null }>(),
    'Load QualitativeInputs Success': props<{ qualitative: QualitativeProcess[], totalElements?: any }>(),
    'Load QualitativeInputs Failure': props<{ error: any }>(),
    'Load All Qualitative Inputs': props<{ legalEntityId: string, campaignId: string, params?: any }>(),
    'Load All Qualitative Inputs Success': props<{ qualitative: QualitativeProcess[] }>(),
    'Load All Qualitative Inputs Failure': props<{ error: any }>(),
    'Add QualitativeInput': props<{ qualitativeInput: QualitativeInput }>(),
    'Upsert QualitativeInput': props<{ qualitativeInput: QualitativeInput }>(),
    'Add QualitativeInputs': props<{ qualitativeInputs: QualitativeInput[] }>(),
    'Upsert QualitativeInputs': props<{ qualitativeInputs: QualitativeInput[] }>(),
    'Update QualitativeInput': props<{ questionId: string, id: string, comments: string, levelRelevanceId: string, opinionId: string, cptId: string }>(),
    'Update QualitativeInput Success': props<{ status: boolean, cptId: string, questionId: string }>(),
    'Update QualitativeInput Failure': props<{ error: any, cptId: string, questionId: string }>(),
    'Update QualitativeInputs': props<{ qualitativeInputs: Update<QualitativeInput>[] }>(),
    'Delete QualitativeInput': props<{ id: string }>(),
    'Delete QualitativeInputs': props<{ ids: string[] }>(),
    'Clear QualitativeInputs': emptyProps(),
    'Create QualitativeInput': props<{
      questionId: string,
      opinionId: string,
      legalEntityId: string,
      comments: string,
      campaignId: string,
      cptId: string
    }>(),
    'Create QualitativeInput Success': props<{ status: boolean, cptId: string, questionId: string }>(),
    'Create QualitativeInput Failure': props<{ error: any, cptId: string, questionId: string }>()
  }
});
